import { useKindeAuth } from '@kinde-oss/kinde-auth-react'
import { StyledLoginButton } from './styled'
import { Box } from '@mui/material'
import { cn } from 'lib/utils'
import { removeLocalStorageData } from 'utils/localStorage'

interface AuthorizationButtonProps {
  type?: 'login' | 'logout'
  mode?: 'dark' | 'light'
  className?: string
  disabled?: boolean
  isHeader?: boolean
}

export const AuthorizationButton: React.FC<AuthorizationButtonProps> = ({
  type = 'login',
  mode = 'light',
  className = '',
  disabled = false,
  isHeader = false
}: AuthorizationButtonProps) => {
  const { login, logout } = useKindeAuth()

  const handlerLogout = () => {
    removeLocalStorageData('user_data')
    logout()
  }

  const loginText = isHeader ? 'התחבר' : 'התחבר | הירשם'

  return (
    <StyledLoginButton
      className={cn(className, mode)}
      onClick={() => (type === 'login' ? login() : handlerLogout())}
      disabled={disabled}
      disableRipple
    >
      {type === 'login' ? loginText : 'להתנתק'}
    </StyledLoginButton>
  )
}
